import clsx from "clsx"
import PropTypes from "prop-types"
import { TiDeleteOutline } from "react-icons/ti"

const ClientMultiSelect = ({
  label,
  id,
  className,
  options,
  handleChange,
  selected = [],
}) => {
  return (
    <div className={clsx("flex flex-col mb-4 w-full", className && className)}>
      <label
        htmlFor={id}
        className="mt-4 mb-2 text-xs text-brand-secondary font-semibold"
      >
        {label}
      </label>
      <select
        id={id}
        className={clsx(
          "border border-gray1 rounded-lg px-4 flex justify-between items-center h-full bg-[transparent] triangle-down-select-icon search-input bg-gray1 text-[12px]",
          className && className,
        )}
        onChange={(e) => {
          handleChange([...selected, e.target.value])
        }}
        value=""
      >
        <option value="" disabled>
          Select a client
        </option>

        {options?.map((option) => {
          return (
            <option
              key={option.id}
              value={option.id}
              disabled={selected
                .map((s) => (typeof s === "string" ? Number(s) : s.client_id))
                .includes(option.id)}
            >
              {option.name}
            </option>
          )
        })}
      </select>
      <div className="flex gap-1 mt-2 flex-wrap">
        {selected?.map((item, index) => {
          return (
            <div
              key={index}
              className="border p-2 rounded-xl bg-[#c8e5e7] flex items-center text-[14px] gap-1 flex-wrap"
            >
              {
                options.find(
                  (o) =>
                    o.id ===
                    (typeof item === "string" ? Number(item) : item.client_id),
                )?.name
              }
              <button
                onClick={() => {
                  handleChange(selected.filter((it) => it !== item))
                }}
              >
                <TiDeleteOutline className="w-5 h-5" />
              </button>
            </div>
          )
        })}
      </div>
    </div>
  )
}

ClientMultiSelect.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  options: PropTypes.array,
  handleChange: PropTypes.func,
  selected: PropTypes.array,
}

export default ClientMultiSelect
